import { Component, Input, ChangeDetectorRef, inject } from '@angular/core';
import { BildungsangebotTerminDetail, Termin } from '../../model';
import { getDauerKurzbezeichnungWithTimeRefence } from '../../model/dauer';

import { DurationPipe } from '../../shared/pipes/duration/duration.pipe';

@Component({
  selector: 'now-wbsuche-lib-dauer-anzeige',
  templateUrl: './dauer-anzeige.component.html',
  imports: [DurationPipe]
})
export class DauerAnzeigeComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  // Use a setter to detect when the termin input changes
  private _termin!: Termin | BildungsangebotTerminDetail;

  @Input()
  set termin(value: Termin | BildungsangebotTerminDetail) {
    this._termin = value;
    this.changeDetectorRef.markForCheck();
  }

  get termin() {
    return this._termin;
  }

  getDauerKurzbezeichnung = (id: number) => getDauerKurzbezeichnungWithTimeRefence(id)?.label;
}
